import { useI18n } from 'vue-i18n';
import * as yup from 'yup';

export default () => {
  const { t } = useI18n();
  const schema = yup.object({
    repeatBy: yup.string().required('errorMessages.required'),
    repeatEvery: yup.number().required('errorMessages.required'),
  });

  return {
    schema,
  };
};
